import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { confirmPopup } from "primereact/confirmpopup";
import { deleteOurClient, getOurClients } from "../../redux/actions/OurClientAction";

export default function Index() {
    const history = useHistory();
    const dispatch = useDispatch();
    let { allOurClients } = useSelector((state) => state?.ourClient)
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");

    useEffect(() => {
        dispatch(getOurClients(setLoading));
    }, [dispatch]);

    const onDelete = (e, id) => {
        confirmPopup({
            target: e.currentTarget,
            message: "Are you sure you want to delete this client? This action will permanently delete the client account. This action cannot be undone.",
            icon: "pi pi-exclamation-triangle",
            accept: () => dispatch(deleteOurClient(id)),
            reject: () => { },
        });
    };

    const getFilteredData = (data, search) => {
        if (search?.length) {
            const lowerSearch = search.toLowerCase();
            return data.filter((item) => {
                const title = item?.title?.toLowerCase() || '';
                const authorName = item?.author?.name?.toLowerCase() || '';
                const authorRole = item?.author?.role?.toLowerCase() || '';

                return (
                    title.includes(lowerSearch) ||
                    authorName.includes(lowerSearch) ||
                    authorRole.includes(lowerSearch)
                );
            });
        }
        return data;
    };

    allOurClients = getFilteredData(allOurClients, search);

    return {
        allOurClients,
        loading,
        history,
        search,
        setSearch,
        onDelete,
    };
}
